import React, { useEffect, useState, useRef }from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import T, { Translate } from '../../i18n/i18n';
import { Title, ButtonIcon, ButtonBack, HeaderRow, TemplateList, TemplateItem, TemplateItemInfo, TemplateItemIcons, TemplateItemName, TemplateItemCreatedBy, TemplateIconOwner, TemplateIconEditor, TemplateIconStaff, TemplateAdd, TemplateIconAdd } from './TemplatesList.styles';
import { myTemplates } from '../../../services/templates';

export default () => {

    const [templates, setTemplates] = useState([]);

    const playerId = useSelector(state => state.authState.id);
    const history = useHistory();

    const handleRefresh = () => {
        let update = true;

        (async () => {
            let data = await myTemplates();
            if (update) {
                setTemplates(data);
            }
        })();

        return ()=>{update = false;}
    }

    const handleBack = () => {
        history.goBack();
    };

    const handleOpenSheet = (id) => {
        history.push(`/templatebuilder/${id}`);
    };

    const handleCreate = (e) => {
        history.push('/templatebuilder');
    }

    useEffect(()=>{
        let fn = handleRefresh();
        return fn;
    },[]);
    
    return <>
        <HeaderRow>
            <ButtonBack color="#aaa" onClick={handleBack} />
            <Title><T value="templatemanager.titleMin" /></Title>
            <ButtonIcon color="#f92" onClick={handleRefresh} icon="\F0450" title={Translate("tables.refresh")} />
        </HeaderRow>
        <TemplateList>
            {templates && templates.length ? templates.map(t => <TemplateItem key={t.id} onClick={()=>{handleOpenSheet(t.id)}}>
                <TemplateItemInfo>
                    <TemplateItemName>{t.name}</TemplateItemName>
                    <TemplateItemCreatedBy>{t.system && t.system.length ? t.system[0][Translate("lang")] : Translate("templatemanager.nosystem") } | {t.createdBy}</TemplateItemCreatedBy>
                </TemplateItemInfo>
                <TemplateItemIcons>
                    {t.owner === playerId ? <TemplateIconOwner title={Translate('templatemanager.owner')} /> : null}
                    {t.editableTo.includes(playerId) ? <TemplateIconEditor title={Translate('templatemanager.editor')} /> : null}
                    {t.staffChoice ? <TemplateIconStaff title={Translate('templatemanager.staff')} /> : null}
                </TemplateItemIcons>
            </TemplateItem>) : null}
            <TemplateAdd onClick={()=>{handleCreate()}}>
                <TemplateIconAdd />
                <span><T value="templatemanager.create" /></span>
            </TemplateAdd>
        </TemplateList>
    </>
};